import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularUpDownArrows: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_up-down-arrows"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="up-down-arrows icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M15.7234 20.6675C15.8999 20.8694 16.1812 21 16.4981 21C16.8134 21 17.0935 20.8707 17.2702 20.6705C17.2978 20.6494 17.3244 20.6269 17.3501 20.6032L20.742 17.4662C21.1053 17.1303 21.0821 16.6054 20.6902 16.294C20.2984 15.9825 19.6862 16.0024 19.323 16.3384L17.4656 18.0562V3.8295C17.4656 3.37138 17.0324 3 16.4981 3C15.9637 3 15.5306 3.37138 15.5306 3.8295V18.055L13.6744 16.3384C13.3112 16.0024 12.699 15.9825 12.3072 16.294C11.9153 16.6054 11.8921 17.1303 12.2554 17.4662L15.6473 20.6032C15.6718 20.6258 15.6972 20.6473 15.7234 20.6675Z" />
        <path d="M6.72598 3.3325C6.90245 3.13063 7.18377 3 7.50067 3C7.81601 3 8.09612 3.12935 8.27275 3.32953C8.30034 3.35063 8.32704 3.37306 8.35272 3.39681L11.7446 6.53377C12.1079 6.86973 12.0847 7.39457 11.6928 7.70601C11.301 8.01746 10.6888 7.99759 10.3256 7.66163L8.46817 5.94383V20.1705C8.46817 20.6286 8.035 21 7.50067 21C6.96633 21 6.53316 20.6286 6.53316 20.1705V5.94499L4.67703 7.66163C4.31376 7.99759 3.70161 8.01746 3.30975 7.70601C2.9179 7.39457 2.89472 6.86973 3.25798 6.53377L6.64987 3.39681C6.67435 3.37417 6.69975 3.35273 6.72598 3.3325Z" />
      </svg>
    </span>
  );
};

export { RegularUpDownArrows };
